import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import { BuyersInitialState } from '../globalSlices/buyersSlice';
import {
  downloadMultiInvoicePdfZip,
  getBasicSupplier,
  getGroupedBuyersSuppliers,
  getInvoicePdf,
  getMainBuyer,
  addSendgridApiKeyToMainBuyer,
  downloadInvoicePdfReceipt,
  getDocumentPdf,
  supplierInviteUsersForBuyer,
  getBuyerStatementPeriods,
  fetchBuyerMonthlyAnalytics,
  updateBuyerAutopay,
  deleteBuyerUser,
} from '../services/buyersService';

export const getGroupedBuyersSuppliersExtraReducer = (
  builder: ActionReducerMapBuilder<BuyersInitialState>
) => {
  const reducerId = 'getGroupedBuyersSuppliers';
  builder.addCase(getGroupedBuyersSuppliers.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.selectedBuyerSuppliers = [];
  });
  builder.addCase(
    getGroupedBuyersSuppliers.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      if (action.payload) {
        state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      }
      if (action.payload && action.payload.success && action.payload?.data.buyerSuppliers) {
        state.selectedBuyerSuppliers = action.payload?.data.buyerSuppliers;
      }
    }
  );
  builder.addCase(getGroupedBuyersSuppliers.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getBasicSupplierExtraReducer = (
  builder: ActionReducerMapBuilder<BuyersInitialState>
) => {
  const reducerId = 'getBasicSupplier';
  builder.addCase(getBasicSupplier.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.basicSupplier = null;
  });
  builder.addCase(
    getBasicSupplier.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.basicSupplier = action.payload?.data;
      } else {
        state.basicSupplier = null;
      }
    }
  );
  builder.addCase(getBasicSupplier.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    state.basicSupplier = null;
  });
};

export const getInvoicePdfExtraReducer = (builder: ActionReducerMapBuilder<BuyersInitialState>) => {
  const reducerId = 'getInvoicePdf';
  builder.addCase(getInvoicePdf.pending, (state, action) => {
    state.invoiceBase64 = null;
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getInvoicePdf.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.previewPdf = action.payload?.data?.pdfUrl;
      } else {
        state.previewPdf = null;
      }
    }
  );
  builder.addCase(getInvoicePdf.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    // state.invoiceBase64 = null;
  });
};

export const getDocumentPdfExtraReducer = (
  builder: ActionReducerMapBuilder<BuyersInitialState>
) => {
  const reducerId = 'getDocumentPdf';
  builder.addCase(getDocumentPdf.pending, (state, action) => {
    state.invoiceBase64 = null;
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getDocumentPdf.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.previewPdf = action.payload?.data?.pdfUrl;
      } else {
        state.previewPdf = null;
      }
    }
  );
  builder.addCase(getDocumentPdf.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    // state.invoiceBase64 = null;
  });
};

export const downloadMultiInvoicePdfZipExtraReducer = (
  builder: ActionReducerMapBuilder<BuyersInitialState>
) => {
  const reducerId = 'downloadMultiInvoicePdfZip';
  builder.addCase(downloadMultiInvoicePdfZip.pending, (state, action) => {
    state.invoiceBase64 = null;
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    downloadMultiInvoicePdfZip.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
      } else {
      }
    }
  );
  builder.addCase(downloadMultiInvoicePdfZip.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
// export const updateBuyerExtraReducer = (builder: ActionReducerMapBuilder<BuyersInitialState>) => {
//   const reducerId = 'updateBuyer';
//   builder.addCase(updateBuyer.pending, (state, action) => {
//     state.loadingList = [...new Set([...state.loadingList, reducerId])];
//   });
//   builder.addCase(
//     updateBuyer.fulfilled,
//     (state, action: PayloadAction<AppServerResponse | null>) => {
//       state.loadingList = state.loadingList.filter((item) => item !== reducerId);
//       // if (
//       //   action.payload &&
//       //   action.payload.success &&
//       //   action.payload?.data &&
//       //   state.selectedBuyersGroup?.buyers
//       // ) {
//       //   const updatedBuyer = { ...state.selectedBuyersGroup };
//       //   const index = state.selectedBuyersGroup?.buyers.findIndex(
//       //     (buyer) => buyer.id === action.payload?.data.id
//       //   );
//       //   updatedBuyer.buyers[index] = action.payload?.data;
//       // }
//     }
//   );
//   builder.addCase(updateBuyer.rejected, (state, action: PayloadAction<any>) => {
//     state.loadingList = state.loadingList.filter((item) => item !== reducerId);
//   });
// };

export const getMainBuyerExtraReducer = (builder: ActionReducerMapBuilder<BuyersInitialState>) => {
  const reducerId = 'getMainBuyer';
  builder.addCase(getMainBuyer.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.mainBuyer = null;
  });
  builder.addCase(
    getMainBuyer.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.mainBuyer = action.payload?.data;
      }
    }
  );
  builder.addCase(getMainBuyer.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const addSendgridApiKeyToMainBuyerExtraReducer = (
  builder: ActionReducerMapBuilder<BuyersInitialState>
) => {
  const reducerId = 'addSendgridApiKeyToMainBuyer';
  builder.addCase(addSendgridApiKeyToMainBuyer.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    addSendgridApiKeyToMainBuyer.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(addSendgridApiKeyToMainBuyer.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const downloadInvoicePdfReceiptExtraReducer = (
  builder: ActionReducerMapBuilder<BuyersInitialState>
) => {
  const reducerId = 'downloadInvoicePdfReceipt';
  builder.addCase(downloadInvoicePdfReceipt.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    downloadInvoicePdfReceipt.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(downloadInvoicePdfReceipt.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const supplierInviteUsersForBuyerExtraReducer = (
  builder: ActionReducerMapBuilder<BuyersInitialState>
) => {
  const reducerId = 'supplierInviteUsersForBuyer';
  builder.addCase(supplierInviteUsersForBuyer.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    supplierInviteUsersForBuyer.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(supplierInviteUsersForBuyer.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getBuyerStatementPeriodsExtraReducer = (
  builder: ActionReducerMapBuilder<BuyersInitialState>
) => {
  const reducerId = 'getBuyerStatementPeriods';
  builder.addCase(getBuyerStatementPeriods.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.loadingStatementPeriods = true;
  });
  builder.addCase(
    getBuyerStatementPeriods.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      state.loadingStatementPeriods = false;
      if (action.payload && action.payload.success && action.payload?.data?.statementPeriods) {
        state.statementPeriods = action.payload.data.statementPeriods;
      }
    }
  );
  builder.addCase(getBuyerStatementPeriods.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    state.loadingStatementPeriods = false;
  });
};

export const fetchBuyerMonthlyAnalyticsExtraReducer = (
  builder: ActionReducerMapBuilder<BuyersInitialState>
) => {
  const reducerId = 'fetchBuyerMonthlyAnalytics';
  builder.addCase(fetchBuyerMonthlyAnalytics.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.loadingMonthlyAnalytics = true;
  });
  builder.addCase(
    fetchBuyerMonthlyAnalytics.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      state.loadingMonthlyAnalytics = false;
      if (action.payload && action.payload.success && action.payload?.data?.monthlyAnalytics) {
        state.monthlyAnalytics = action.payload.data.monthlyAnalytics;
      }
    }
  );
  builder.addCase(fetchBuyerMonthlyAnalytics.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    state.loadingMonthlyAnalytics = false;
  });
};

export const updateBuyerAutopayExtraReducer = (
  builder: ActionReducerMapBuilder<BuyersInitialState>
) => {
  const reducerId = 'updateBuyerAutopay';
  builder.addCase(updateBuyerAutopay.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    updateBuyerAutopay.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (
        action.payload?.success &&
        action.payload?.data &&
        state.selectedBuyerSuppliers.length > 0
      ) {
        const updatedBuyer = action.payload.data;
        const index = state.selectedBuyerSuppliers.findIndex(
          (s) => s.buyer?.id === updatedBuyer.id
        );
        if (index !== -1) {
          state.selectedBuyerSuppliers[index] = {
            ...state.selectedBuyerSuppliers[index],
            buyer: updatedBuyer,
          };
        }
      }
    }
  );
  builder.addCase(updateBuyerAutopay.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const deleteBuyerUserExtraReducer = (
  builder: ActionReducerMapBuilder<BuyersInitialState>
) => {
  const reducerId = 'deleteBuyerUser';
  builder.addCase(deleteBuyerUser.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    deleteBuyerUser.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(deleteBuyerUser.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
